
















import {
  Component, Prop, PropSync, Vue,
} from 'vue-property-decorator';
import Choice from '@/models/entry/Choice';

@Component
export default class ExamCheckbox extends Vue {
  @Prop()
  private choices: Choice[];

  @PropSync('choiceCodes', { type: Array })
  private answer: string[];

  isSelectedCheck(code: string) {
    return this.answer.findIndex((selectedCode) => selectedCode === code);
  }

  select(code: string) {
    const index = this.isSelectedCheck(code);
    if (index > -1) {
      this.answer.splice(index, 1);
      return;
    }
    this.answer.push(code);
  }
}
